// extracted by mini-css-extract-plugin
export default {"container":"zYBDbjsQZ7a07BZEYptd","isCenterAligned":"f535Wx9UiUW1S7TaQxma"};